import React from 'react';
import { CodetableItemLoader } from 'app/area/shared/codetable/item/codetable-item-loader';
import { HierarchyMetadata } from 'app/area/shared/codetable/list-item/types';
import { CodetableItemRow } from 'app/area/codetable/list/list-items/common/codetable-item-row';

import { LinkCodesActionType, LinkCodesTranslation } from '../constants';
import { ListBranch, ListBranchState, Visibility } from '../types-store';
import { RowSelection } from '../types';
import { ListItem } from './list-item';
import { ListItemsContainer } from './list-items-container';
import { getCurrentBranchItems } from 'app/area/link-codes/utils/get-current-branch-items';

interface ListItemsProps {
  listBranch: ListBranch[];
  listBranchState: ListBranchState[];

  visiblity: Visibility;
  checkedValues: { [id: number]: boolean };
  selectedRows: number[][];
  path: number[];

  hierarchyMode: boolean;
  hierarchyMetadata: HierarchyMetadata[];
  isZebra: boolean;

  expandItem: (id: number) => void;
  selectRow: (selection: RowSelection) => void;
  addAction: (path: number[], type: LinkCodesActionType, propagate: boolean) => void;
  loadFromParent: (id: number, startIndex: number) => void;

  translation: LinkCodesTranslation;
}

export const ListItems: React.FC<ListItemsProps> = ({
  listBranch, listBranchState, visiblity, checkedValues, selectedRows,
  path, hierarchyMode, hierarchyMetadata, isZebra,
  expandItem, selectRow, addAction, loadFromParent, translation
}) => {

  const id = path.length > 0 ? path[path.length - 1] : 0;
  const currentBranch = listBranch.find(branch => branch.id === id);
  const currentBrunchItems = getCurrentBranchItems(id, listBranch, checkedValues, visiblity);
  const currentBranchState = listBranchState.find(branch => branch.id === id);
  const fetching = !!currentBranchState?.fetching;

  return <>
    <ListItemsContainer
      listBranch={currentBranch}
      listBranchState={currentBranchState}
      id={id}
      loadFromParent={loadFromParent}>

      {currentBrunchItems
        .map((item, index) => {

          const isLastChild = currentBrunchItems.length === index + 1;
          const hasChildren = hierarchyMode && !!item.childrenCount;

          const currentHierarchyMetadata: HierarchyMetadata[] = [
            ...hierarchyMetadata, {
              depthLevel: path.length,
              hasChildren,
              isLastChild
            }];

          const itemBranchState = listBranchState.find(branch => branch.id === item.id);
          const itemPath = [...path, item.id];
          const open = !!itemBranchState?.open;

          const isZebraValue = isZebra === undefined ? index % 2 === 0 : isZebra;

          return <div key={item.id}>
            <ListItem
              item={item}
              path={itemPath}
              checked={checkedValues[item.id] ?? false}
              rowSelected={selectedRows.some(row => row[row.length - 1] === item.id)}
              treeDepthLevel={path.length}
              hierarchyMode={hierarchyMode}
              hierarchyMetadata={currentHierarchyMetadata}

              isZebra={isZebraValue}
              open={open}
              expandItem={expandItem}
              selectRow={selectRow}
              addAction={addAction}
              translation={translation}
            />
            {open && <div>
              <ListItems
                listBranch={listBranch}
                listBranchState={listBranchState}
                visiblity={visiblity}
                checkedValues={checkedValues}
                selectedRows={selectedRows}
                path={itemPath}
                hierarchyMode={hierarchyMode}
                hierarchyMetadata={currentHierarchyMetadata}
                isZebra={isZebraValue}
                expandItem={expandItem}
                selectRow={selectRow}
                addAction={addAction}
                loadFromParent={loadFromParent}
                translation={translation}
              />
            </div>}
          </div>;
        })}
    </ListItemsContainer>
    {fetching && <CodetableItemRow isZebra={isZebra} isLoader>
      <CodetableItemLoader>
        {translation.loading}
      </CodetableItemLoader>
    </CodetableItemRow>}
  </>;
};
